import { SelectablePanel } from '@app/components/base/selectable-panel';
import { SocialPlatformIcon } from '@app/modules/social-export/components/SocialPlatformIcon';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Typography } from '@mui/material';

import { publishPlatformBarTileSx } from './publish-platform-bar-sizes';

type PublishPlatformBarItemProps = {
  platform: SocialPlatform;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

/**
 * Single platform tile in the publish platform bar (icon + label).
 */
export function PublishPlatformBarItem({
  platform,
  selected,
  disabled = false,
  onSelect,
}: PublishPlatformBarItemProps) {
  return (
    <SelectablePanel
      selected={selected}
      selectedAnchor="bottom"
      orientation="column"
      disabled={disabled}
      onClick={onSelect}
      sx={publishPlatformBarTileSx}
    >
      <SocialPlatformIcon platform={platform} size="lg" />
      <Typography
        variant="caption"
        component="span"
        noWrap
        sx={{
          width: 1,
          textAlign: 'center',
          color: selected ? 'text.primary' : 'text.secondary',
        }}
      >
        {platform.name}
      </Typography>
    </SelectablePanel>
  );
}
